export default __webpack_public_path__ + "resources/icons/d342-f0fe.png";